<template>
  <div>
    <b-row>
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
            <h5 class="float-left"><i class='fa fa-search'></i> Search</h5>
          </b-card-header>
          <b-card-body>
            <b-form>
              <b-row>
                <b-col sm="2">
                  <label class="mr-sm-2" for="sStartTime">From (yyyy/mm/dd 00:00:00)</label>
                  <b-input id="sStartTime" type="date" placeholder="" v-model.trim="sStartTime" :state="$v.sStartTime.$error?false:null" @blur.native="$v.sStartTime.$touch"></b-input>
                  <div v-if="$v.sStartTime.$error">
                    <div class="invalid-feedback d-block" v-if="!$v.sStartTime.required">Start Time is required</div>
                    <div class="invalid-feedback d-block" v-if="!$v.sStartTime.rangeInvalid">Date Range should be equal to or below {{ reportDateLimit }} months</div>
                  </div>
                </b-col>
                <b-col sm="2">
                  <label class="mr-sm-2" for="sEndTime">To (yyyy/mm/dd 23:59:59)</label>
                  <b-input id="sEndTime" type="date" placeholder="" v-model.trim="sEndTime" :state="$v.sEndTime.$error?false:null" @blur.native="$v.sEndTime.$touch"></b-input>
                  <div v-if="$v.sEndTime.$error">
                    <div class="invalid-feedback d-block" v-if="!$v.sEndTime.required">Start Time is required</div>
                    <div class="invalid-feedback d-block" v-if="!$v.sEndTime.rangeInvalid">Date Range should be equal to or below {{ reportDateLimit }} months</div>
                  </div>
                </b-col>
                <b-col sm="2">
                  <label class="mr-sm-2" for="sBrand">Brand</label>
                  <b-form-select id="sBrand" :plain="true" :options="brandOption" v-model="sBrand" text-field="Code" value-field="Code">
                    <template slot="first">
                      <option :value="null">-- Please select an option --</option>
                    </template>
                  </b-form-select>
                </b-col>
                <b-col sm="2">
                  <label class="mr-sm-2" for="sGame">Game List</label>
                  <b-form-select id="sGame" :plain="true" :options="gameOption" v-model="sGame" text-field="GameName" value-field="GameId">
                    <template slot="first">
                      <option :value="null">-- Please select an option --</option>
                    </template>
                  </b-form-select>
                </b-col>
                <b-col sm="2" class="align-self-end">
                  <b-button id="sBtn" variant="primary" @click="search" :disabled="$v.sStartTime.$invalid || $v.sEndTime.$invalid"><i class="fa fa-search"></i> Search</b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
            <h5 class="float-left"><i class="fa fa-bar-chart"></i> High Turnover Games Promotion Risk</h5>
            <div class="clearfix"></div>
            <h6><strong>Netwin <span class="text-danger">-ve</span> = Member Win</strong></h6>
            <h6><strong>Netwin <span class="text-success">+ve</span> = Member Loose</strong></h6>
          </b-card-header>
          <b-card-body>
            <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields">
              <template v-slot:cell(Turnover)="data">
                {{ format(data.item.Turnover, '0,0.00') }}
              </template>
              <template v-slot:cell(NetWin)="data">
                {{ format(data.item.NetWin, '0,0.00') }}
              </template>
              <template v-slot:row-details="data">
                <!-- {{ data.item.details }} -->
                <turnover-detail :details="data.item.details"/>
              </template>
              <template v-slot:cell(Action)="data">
                <b-btn variant="primary" class="btn-sm" @click="viewDetail(data.item)">See Detail</b-btn>
              </template>
            </b-table>
            <nav>
              <b-pagination :total-rows="getRowCount(items)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" />
            </nav>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { Events } from '../../../../events.js'
import numeral from 'numeral'
import VueNotifications from 'vue-notifications'
import TurnoverDetail from './TurnoverDetail'
const moment = require('moment-timezone')

export default {
  name: 'high-turnover-report-table',
  props: {
    caption: {
      type: String,
      default: 'Table'
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      items: [],
      fields: [
        {key: 'Action', label: 'Action', thStyle: { width: '100px' }},
        {key: 'Brand', label: 'Brand'},
        {key: 'GameName', label: 'Game Name'},
        {key: 'AccountingDate', label: 'AccountingDate'},
        {key: 'Turnover', label: 'Turnover'},
        {key: 'NetWin', label: 'NetWin'}
      ],
      perPage: 50,
      currentPage: 1,
      rowCount: 0,
      brandOption: [],
      gameOption: [],
      sStartTime: moment().tz('Asia/Taipei').subtract(1, 'days').format('YYYY-MM-DD'),
      sEndTime: moment().tz('Asia/Taipei').subtract(1, 'days').format('YYYY-MM-DD'),
      sBrand: null,
      sGame: null,
      reportDateLimit: 1
    }
  },
  components: {
    TurnoverDetail
  },
  watch: {
    sBrand: function () {
      this.getGameList()
    },
    currentPage: function () {
      this.search()
    }
  },
  validations: {
    sStartTime: {
      required,
      rangeInvalid: function () {
        return this.validateDateRange()
      }
    },
    sEndTime: {
      required,
      rangeInvalid: function () {
        return this.validateDateRange()
      }
    }
  },
  methods: {
    getRowCount () {
      return this.rowCount
    },
    format (num, fmt) {
      return numeral(num).format(fmt)
    },
    validateDateRange () {
      return !(Math.abs(moment(this.sStartTime).diff(this.sEndTime, 'months', true)) > this.reportDateLimit)
    },
    async getBrand () {
      try {
        Events.$emit('loader')
        let { data } = await this.$http.post(this.API_ENDPOINT + '/game/v2/platform/getList', { headers: { 'Content-Type': 'application/json' } })
        this.brandOption = data.list
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        Events.$emit('loader')
      }
    },
    async getGameList (params) {
      try {
        Events.$emit('loader')
        let { data } = await this.$http.get(this.API_ENDPOINT + `/game/gamelist?brand=${this.sBrand}`, { headers: { 'Content-Type': 'application/json' } })
        let game = data.list.map(x => { return { GameId: `${x.GameId}-${x.GameKindId}`, GameName: x.GameName } })
        this.gameOption = game
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        Events.$emit('loader')
      }
    },
    async search () {
      try {
        Events.$emit('loader')
        let gameId = (this.sGame) ? this.sGame.split('-')[0] : ''
        let queryStr = `?page=${this.currentPage}&size=${this.perPage}&brand=${this.sBrand || ''}&gameId=${gameId}&from=${this.sStartTime}&to=${this.sEndTime}`
        let { data } = await this.$http.get(this.API_ENDPOINT + '/report/promotion/risk/highturnover' + queryStr, { headers: { 'Content-Type': 'application/json' } })
        this.items = data.result
        this.rowCount = data.rowCount
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        Events.$emit('loader')
      }
    },
    async viewDetail (item) {
      if (item._showDetails) {
        item._showDetails = false
      } else {
        if (item.details) {
          item._showDetails = true
        } else {
          try {
            Events.$emit('loader')
            let queryStr = `?date=${item.AccountingDate}&brand=${item.Brand}&gameId=${item.GameType}`
            let { data } = await this.$http.get(this.API_ENDPOINT + '/report/promotion/risk/highturnover/detail' + queryStr, { headers: { 'Content-Type': 'application/json' } })
            item.details = data
            this.$set(item, '_showDetails', true)
          } catch (err) {
            console.log('this is an error ', err)
            Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
            item._showDetails = false
          } finally {
            Events.$emit('loader')
          }
        }
      }
    }
  },
  created () {
    this.getBrand()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/report/risk/promotion/HighTurnoverReportTable.vue